import React, { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import * as AppState from '../../../../AppState';
import MinMaxInputs from '../../../Shared/MinMaxInputs/MinMaxInputs';

const PriceRange = (props: { wrapperClass?: string }) => {
	const [gsFilters, setGsFilters] = useRecoilState(AppState.gsFilters);

	const [minValue, setMinValue] = React.useState<string>(gsFilters.priceMin === 0 ? '' : gsFilters.priceMin.toString());
	const [maxValue, setMaxValue] = React.useState<string>(gsFilters.priceMax === -1 ? '' : gsFilters.priceMax.toString());

	// Handles filter reset
	useEffect(() => {
		setMinValue(gsFilters.priceMin === 0 ? '' : gsFilters.priceMin.toString());
		setMaxValue(gsFilters.priceMax === -1 ? '' : gsFilters.priceMax.toString());
	}, [gsFilters]);

	return (
		<MinMaxInputs
			id="priceRangeFilter"
			wrapperClass={props.wrapperClass ? props.wrapperClass : 'w-100'}
			minLabel='Min Price'
			maxLabel='Max Price'
			minValue={minValue}
			maxValue={maxValue}
			globalMinValue={gsFilters.priceMin}
			globalMaxValue={gsFilters.priceMax}
			setMinValue={setMinValue}
			setMaxValue={setMaxValue}
			callback={([min, max]) => setGsFilters(currVal => ({
				...currVal,
				priceMin: min,
				priceMax: max
			}))}
			commaSeparated
			currency
		/>
	);
};

export default PriceRange;
